import React, { useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Collapse,
  Form,
  Input,
  Layout,
  notification,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { CustomButton, CustomSelector } from '../../../components';
import {
  ajaxTablePersons as filterPerson,
  deactivatePersons,
  getCharges,
  getProjectsActive,
} from '../../../api/module/project_person';
import { deactivateUnit, queryUnit as filterUnit } from '../../../api/module/unit';
import { getStructureTypes } from '../../../api/module/structure';
import AjaxTable from '../../../components/AjaxTable';
import {
  EditFilled,
  SearchOutlined,
  UserDeleteOutlined,
  UsergroupDeleteOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import CreateUpdateUnit from '../Unit/create_update';
import BindPeopleToUnits from '../people/bind_units';
import { deleteUnitPerson, queryUnitPersonPersons, queryUnitPersonUnits } from '../../../api/module/unit_person';
import MESSAGES from '../../../enums/Messages';
import BindUnitsToPersons from '../Unit/bind_persons';
import { catchException } from '../../../utils/helpers/helpers';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function UnitsPeople() {
  const [formSearchPersons] = Form.useForm();
  const [formSearchUnits] = Form.useForm();
  const [selectedProject, setSelectedProject] = useState(undefined);
  const [grouping, setGrouping] = useState(undefined);
  const [groupByUnits, setGroupByUnits] = useState(false);
  const [groupByPersons, setGroupByPersons] = useState(false);
  const [queryUnits, setQueryUnits] = useState(undefined);
  const [queryPersons, setQueryPersons] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [selectorKey, setSelectorKey] = useState(Date.now());
  const [contractPosition, setContractPosition] = useState(undefined);
  const [reloadPerson, setReloadPerson] = useState(false);
  const [reloadPersonNested, setReloadPersonNested] = useState(false);
  const [reloadUnitNested, setReloadUnitNested] = useState(false);
  const [reloadUnit, setReloadUnit] = useState(false);
  const [personsSelection, setPersonsSelection] = useState([]);
  const [unitsSelection, setUnitsSelection] = useState([]);
  const [modalUnit, setModalUnit] = useState(false);
  const [dataUnit, setDataUnit] = useState({});
  const [modalBindPeople, setModalBindPeople] = useState(false);
  const [modalBindUnit, setModalBindUnit] = useState(false);

  const breadcrumbItems = [
    {
      text: 'Unidades - Personas',
    },
  ];

  const columnsPersonBase = [
    {
      title: 'Nombre completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
    },
    {
      title: 'Documento identificación',
      dataIndex: 'numero_identificacion',
      key: 'numero_identificacion',
    },
    {
      title: 'Departamento',
      dataIndex: 'notificacion_ciudad',
      key: 'notificacion_ciudad',
    },
    {
      title: 'Municipio',
      dataIndex: 'notificacion_estado',
      key: 'notificacion_estado',
    },
  ];

  const columnsPersonMain = columnsPersonBase.concat([
      {
        title: 'Acciones',
        dataIndex: 'accion',
        align: 'center',
        fixed: 'right',
        width: 125,
        render: (_, record) => (
          <Space>
            <Tooltip title='Desvincular Persona del proyecto' placement='top'>
              <Popconfirm
                title='Deasvincular Persona'
                description='Está seguro de desvincular esta Persona del proyecto ?'
                onConfirm={() => handleDeactivatePerson(record.id)}
                icon={<WarningOutlined style={{ color: 'red' }} />}>
                <UserDeleteOutlined style={{ fontSize: '18px', color: 'red' }} />
              </Popconfirm>
            </Tooltip>
          </Space>
        ),
      },
  ]);

  const columnsPersonNested = columnsPersonBase.concat([
      {
        title: 'Acciones',
        dataIndex: 'accion',
        align: 'center',
        fixed: 'right',
        width: 125,
        render: (_, record) => (
          <Space>
            <Tooltip title='Desvincular Persona' placement='top'>
              <Popconfirm
                title='Desvincular Persona'
                description='Está seguro de desvincular esta persona ?'
                onConfirm={() => unassignUnitPerson(record)}
                icon={<WarningOutlined style={{ color: 'red' }} />}>
                <UserDeleteOutlined style={{ color: 'red', fontSize: '16px' }} />
              </Popconfirm>
            </Tooltip>
          </Space>
        ),
      },
    ]);

  const expandedRowPersons = (record) => {
    return (
      <AjaxTable
        columns={columnsPersonNested}
        tableTitle={'Personas Asignadas'}
        endpoint={queryUnitPersonPersons}
        reloadSource={reloadPersonNested}
        scroll={{ x: false }}
        query={`filter[unidad]=${record.id}&filter[proyecto]=${selectedProject}&filter[desvinculado]=false`}
        searchInput
      />
    );
  };

  const columnsUnitBase = [
    {
      title: 'Tipo Estructura',
      dataIndex: 'nombre_estructura',
      key: 'nombre_estructura',
    },
    {
      title: 'Detalle 1',
      dataIndex: 'detalle1',
      key: 'detalle1',
    },
    {
      title: 'Detalle 2',
      dataIndex: 'detalle2',
      key: 'detalle2',
    },
    {
      title: 'Detalle 3',
      dataIndex: 'detalle3',
      key: 'detalle3',
    },
    {
      title: 'Detalle 4',
      dataIndex: 'detalle4',
      key: 'detalle4',
    },
    {
      title: 'Estado',
      dataIndex: 'activo',
      key: 'activo',
      render: (text) => (text ? 'A' : 'I'),
    },
  ];

  const columnsUnitMain = columnsUnitBase.concat([
    {
      title: 'Acciones',
      dataIndex: 'accion',
      align: 'center',
      fixed: 'right',
      width: 125,
      render: (_, record) => (
        <Space>
          <Tooltip title='Editar Unidad' placement='top'>
            <EditFilled
              onClick={() => handleEditUnit(record)} style={{ color: 'green', fontSize: '16px' }}
            />
          </Tooltip>
          <Tooltip title='Desvincular Unidad' placement='top'>
            <Popconfirm
              title='Desvincular Unidad del proyecto'
              description='Está seguro de desvincular esta Unidad del proyecto?'
              onConfirm={() => handleDeactivateUnit(record.id)}
              icon={<WarningOutlined style={{ color: 'red' }} />}>
              <UsergroupDeleteOutlined style={{ color: 'red', fontSize: '16px' }} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ]);

  const columnsUnitNested = columnsUnitBase.concat([
    {
      title: 'Acciones',
      dataIndex: 'accion',
      align: 'center',
      fixed: 'right',
      width: 125,
      render: (_, record) => (
        <Space>
          <Tooltip title='Desvincular Unidad' placement='top'>
            <Popconfirm
              title='Desvincular Unidad'
              description='Está seguro de desvincular esta unidad ?'
              onConfirm={() => unassignUnitPerson(record)}
              icon={<WarningOutlined style={{ color: 'red' }} />}>
              <UsergroupDeleteOutlined style={{ color: 'red', fontSize: '16px' }} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ]);

  const expandedRowUnits = (record) => {
    return (
      <AjaxTable
        columns={columnsUnitNested}
        tableTitle={'Unidades Asignadas'}
        endpoint={queryUnitPersonUnits}
        reloadSource={reloadUnitNested}
        scroll={{ x: false }}
        query={`filter[persona]=${record.id}&filter[proyecto]=${selectedProject}&filter[desvinculado]=false`}
        searchInput
      />
    );
  };

  const onSelectChangePerson = newSelectedRowKeys => {
    setPersonsSelection(newSelectedRowKeys);
  };

  const rowPersonsSelected = {
    personsSelection,
    onChange: onSelectChangePerson,
  };

  const onSelectChangeUnit = newSelectedRowKeys => {
    setUnitsSelection(newSelectedRowKeys);
  };

  const rowUnitsSelected = {
    unitsSelection,
    onChange: onSelectChangeUnit,
  };

  const groupingChange = e => {
    let v = e.target.value;
    setGrouping(v);
    initialQuery(v);
  }

  const initialQuery = (type) => {
    if (selectedProject) {
      let filter ="filter[proyecto]="+selectedProject;
      if (type === 'units') {
        setGroupByUnits(true);
        setGroupByPersons(false);
        setQueryUnits(filter)
        resetUnitsForm();
      } else if (type === 'persons') {
        setGroupByPersons(true);
        setGroupByUnits(false);
        setQueryPersons(filter);
        resetPersonsForm();
      }
    }
  };

  const searchUnits = async (values) => {
    let params = Object.entries(values).filter(([_, value]) => value !== undefined)
        .reduce((pv, cv) => {
        pv[`filter[${cv[0]}]`] = cv[1];
        return pv;
    },{});
    params['filter[proyecto]'] = selectedProject;
    const query = new URLSearchParams(params).toString();
    setQueryUnits(query);
  };

  const responseUnit = () => {
    setUnitsSelection([]);
    setDataUnit({});
    setReloadUnit(true);
  };

  const resetProject = (project) => {
    setSelectedProject(project);
    setGrouping(undefined);
    setGroupByPersons(false);
    setGroupByUnits(false);
  };

  const resetUnitsForm = () => {
    formSearchUnits.resetFields();
  };

  const resetPersonsForm = () => {
    formSearchPersons.resetFields();
  };

  const searchPersons = async (values) => {
    let params = Object.entries(values).filter(([_, value]) => value !== undefined)
      .reduce((pv, cv) => {
        pv[`filter[${cv[0]}]`] = cv[1];
        return pv;
      },{});
    params['filter[proyecto]'] = selectedProject;
    const query = new URLSearchParams(params).toString();
    setQueryPersons(query);
  };

  const handleDeactivatePerson = async (id) => {
    try {
      await deactivatePersons(id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
    } catch (error) {
      catchException(error);
    } finally {
      setReloadPerson(true);
    }
  };

  const handleEditUnit = (record) => {
    setDataUnit(record);
    setModalUnit(true);
    setReloadUnit(false);
  };

  const handleDeactivateUnit = async (id) => {
    try {
      await deactivateUnit(id);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "No se puede desactivar la unidad del proyecto.",
        duration: 4,
      });
    } finally {
      setReloadUnit(true);
    }
  };

  const assignUnits = () => {
    if (personsSelection.length > 0) {
      setReloadPerson(false);
      setModalBindUnit(true);
    } else {
      notification.warning({
        message: "Persona Requerida",
        description: "Debe seleccionar al menos una persona para poder asignar unidades.",
        duration: 3,
      });
    }
  };

  const responseBindPeople = () => {
    setUnitsSelection([]);
    setReloadUnit(true);
  }

  const assignPersons = () => {
    if (unitsSelection.length > 0) {
      setReloadUnit(false);
      setModalBindPeople(true);
    } else {
      notification.warning({
        message: "Unidad Requerida",
        description: "Debe seleccionar al menos una unidad para poder asignar personas.",
        duration: 3,
      });
    }
  };

  const unassignUnitPerson = async (record) => {
    try {
      setReloadPersonNested(false);
      setReloadUnitNested(false);
      await deleteUnitPerson(record.id);
      notification.warning({
        message: "Desvinculación de Persona",
        description: "La persona ha sido desvinculada exitosamente.",
        duration: 3,
      });
    } catch (error) {
      console.log(error);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 3,
      });
    } finally {
      setReloadPersonNested(true);
      setReloadUnitNested(true);
    }
  };

  const responseBindUnit = () => {
    setPersonsSelection([]);
    setReloadPerson(true);
  };

  // TODO - add implementation to import massive
  const massiveUpload = () => {
  };

  return (
    <Content>
      <Row>
        <Col span={24}>
          <BreadcrumbContainer items={breadcrumbItems} />
        </Col>
        <Col span={24}>
          <Title className={'text-uppercase'} level={2}>
            Unidades - Personas
          </Title>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col span={3}>
          <Paragraph>Seleccione el Proyecto*:</Paragraph>
        </Col>
        <Col span={17}>
          <CustomSelector
            selectorProps={{
              style: { width: '100%' },
              placeholder:
                'Seleccione el proyecto... ',
            }}
            endpointFetch={async () => {
              return await getProjectsActive();
            }}
            onChange={(value) => resetProject(value)}
          />
        </Col>
      </Row>
      {selectedProject && (
        <>
        <Row>
          <Col span={24}>
            <Radio.Group
              style={{ width: '100%' }}
              value={grouping}
              onChange={groupingChange}
              options={[
                {value: "units", label: "Agrupado por unidades"},
                {value: "persons", label: "Agrupado por personas"},
              ]}
            />
          </Col>
        </Row>
          {groupByUnits && (
            <>
              <Row style={{ marginTop: '20px' }}>
                <Col span={24}>
                  <Collapse items={[
                    {
                      key: '1',
                      label: <Title level={5}>Búsqueda de Unidades</Title>,
                      children:
                        <Form
                          form={formSearchUnits}
                          name="units_search_form"
                          layout="vertical"
                          onFinish={searchUnits}
                        >
                          <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                            <Col span={12}>
                              <Form.Item
                                label="Tipo de unidad:"
                                name="tipo_estructura"
                              >
                                <CustomSelector
                                  key={selectorKey}
                                  selectorProps={{
                                    label: "Tipo de unidad:",
                                    style: { width: '100%' },
                                    placeholder:
                                      'Seleccione el tipo de unidad... ',
                                  }}
                                  endpointFetch={async () => {
                                    return await getStructureTypes();
                                  }}
                                  onChange={setContractPosition}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={11}>
                              <Form.Item
                                label="Estado"
                                name="activo"
                                placeholder="Activos / Inactivos"
                              >
                                <Select>
                                  <Select.Option value="1">Activo</Select.Option>
                                  <Select.Option value="0">Inactivo</Select.Option>
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                            <Col span={12}>
                              <Form.Item label="Detalle 1" name="detalle1">
                                <Input
                                  allowClear
                                  placeholder="Búsqueda por valor de detalle 1"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={11}>
                              <Form.Item label="Detalle 2" name="detalle2">
                                <Input
                                  allowClear
                                  placeholder="Búsqueda por valor de detalle 2"
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                            <Col span={12}>
                              <Form.Item label="Detalle 3" name="detalle3">
                                <Input
                                  allowClear
                                  placeholder="Búsqueda por valor de detalle 3"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={11}>
                              <Form.Item label="Detalle 4" name="detalle4">
                                <Input
                                  allowClear
                                  placeholder="Búsqueda por valor de detalle 4"
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Form.Item wrapperCol={{ span: 24 }}>
                            <Button
                              type="primary"
                              icon={<SearchOutlined />}
                              htmlType="submit"
                              loading={loading}
                            >Buscar</Button>
                            <Button
                              style={{ marginLeft: '20px' }}
                              type="default"
                              onClick={() => {
                                setModalUnit(true);
                                setReloadUnit(false);
                              }}
                            >+ Crear unidad</Button>
                            <Button
                              style={{ marginLeft: '20px' }}
                              danger
                              onClick={() => resetUnitsForm()}
                            >Borrar filtros</Button>
                          </Form.Item>
                        </Form>,
                    }
                  ]}/>
                  {modalUnit ? <CreateUpdateUnit project={selectedProject} parentModalUnit={setModalUnit} responseUnit={responseUnit} dataUnit={dataUnit} /> : ''}
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }} justify={'center'}>
                <Col>
                  <Alert
                    message="Seleccione las unidades a las que desea vincular personas y luego haga click en el boton respectivo."
                    type="info"
                    showIcon
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }} justify={'center'}>
                <Col>
                  <CustomButton
                    type="default"
                    htmlType="button"
                    text="Vincular personas a selección"
                    size="large"
                    onClick={() => assignPersons()}
                  />
                  {modalBindPeople ? <BindPeopleToUnits project={selectedProject} parentModalBindPeople={setModalBindPeople} responseBindPeople={responseBindPeople} units={unitsSelection} /> : ''}
                </Col>
                {/* TODO - Include import massive */}
                {/*<Col style={{ marginLeft: '5px' }}>*/}
                {/*  <CustomButton*/}
                {/*    type="default"*/}
                {/*    htmlType="button"*/}
                {/*    text="Carga Masiva de Unidades/Personas"*/}
                {/*    size="large"*/}
                {/*    onClick={() => massiveUpload()}*/}
                {/*  />*/}
                {/*</Col>*/}
              </Row>
              <Row style={{ marginTop: '20px' }}>
                <Col span={24}>
                  <AjaxTable
                    expandedRowRender={{ expandedRowRender: expandedRowPersons }}
                    tableTitle={'Listado de unidades asignadas al proyecto'}
                    rowKey={'id'}
                    rowSelection={rowUnitsSelected}
                    endpoint={filterUnit}
                    query={queryUnits}
                    columns={columnsUnitMain}
                    searchInput={true}
                    reloadSource={reloadUnit}
                  />
                </Col>
              </Row>
            </>
          )}
          {groupByPersons && (
            <>
              <Row style={{ marginTop: '20px' }}>
                <Col span={24}>
                  <Collapse items={[
                    {
                      key: '1',
                      label: <Title level={5}>Búsqueda de personas</Title>,
                      children:
                        <Form
                          form={formSearchPersons}
                          name="person_search_form"
                          layout="vertical"
                          onFinish={searchPersons}
                        >
                          <Row justify={'space-around'}>
                            <Col span={8}>
                              <Form.Item label="Nombre y apellidos" name="nombre_completo">
                                <Input allowClear placeholder="Búsqueda por nombre" />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item label="Documento" name="numero_identificacion">
                                <Input
                                  type="number"
                                  allowClear
                                  placeholder="Búsqueda por documento"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item label="Correo electrónico" name="notificacion_email">
                                <Input
                                  allowClear
                                  type={'email'}
                                  placeholder="Búsqueda por correo electrónico"
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row justify={'space-around'}>
                            <Col span={24}>
                              <Form.Item label="Cargo:" name="cargo">
                                <CustomSelector
                                  selectorProps={{
                                    style: { width: '100%' },
                                    placeholder: 'Seleccione el cargo contrato... ',
                                  }}
                                  endpointFetch={async () => {
                                    return await getCharges(selectedProject);
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row justify={'space-around'}>
                            <Col span={8}>
                              <Form.Item label="País residencia" name="notificacion_pais">
                                <Input allowClear placeholder="Búsqueda por país" />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item label="Departamento residencia" name="notificacion_estado">
                                <Input
                                  allowClear
                                  placeholder="Búsqueda por departamento"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item label="Municipio de residencia" name="notificacion_ciudad">
                                <Input
                                  allowClear
                                  placeholder="Búsqueda por municipio"
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row justify={'center'}>
                            <Col span={24}>
                              <Form.Item>
                                <Button
                                  type="primary"
                                  icon={<SearchOutlined />}
                                  htmlType="submit"
                                  loading={loading}>
                                  Buscar</Button>
                                <Button
                                  style={{ marginLeft: '20px' }}
                                  danger
                                  onClick={() => formSearchPersons.resetFields()}>
                                  Borrar filtros</Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>,
                    }
                  ]}/>
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }} justify={'center'}>
                <Col>
                  <Alert
                    message="Seleccione las personas a las que desea vincular unidades y luego haga click en el boton respectivo."
                    type="info"
                    showIcon
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }} justify={'center'}>
                <Col>
                  <CustomButton
                    type="default"
                    htmlType="button"
                    text="Vincular unidades a selección"
                    size="large"
                    onClick={() => assignUnits()}
                  />
                  {modalBindUnit ? <BindUnitsToPersons project={selectedProject} parentModalBindUnit={setModalBindUnit} responseBindUnit={responseBindUnit} persons={personsSelection} /> : ''}
                </Col>
                {/* TODO - Include functionality to import massive */}
                {/*<Col style={{ marginLeft: '5px' }}>*/}
                {/*  <CustomButton*/}
                {/*    type="default"*/}
                {/*    htmlType="button"*/}
                {/*    text="Carga Masiva de Unidades/personas"*/}
                {/*    size="large"*/}
                {/*    onClick={() => massiveUpload()}*/}
                {/*  />*/}
                {/*</Col>*/}
              </Row>
              <Row style={{ marginTop: '20px' }}>
                <Col span={24}>
                  <AjaxTable
                    expandedRowRender={{ expandedRowRender: expandedRowUnits }}
                    rowSelection={rowPersonsSelected}
                    tableTitle={'Listado de contratistas asignados al proyecto'}
                    rowKey={'id'}
                    endpoint={filterPerson}
                    query={queryPersons}
                    columns={columnsPersonMain}
                    searchInput={true}
                    reloadSource={reloadPerson}
                  />
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </Content>
  )
}
